import styled from 'styled-components'

import colors from '@galo-monitor/styles/colors'
import fonts from '@galo-monitor/styles/fonts'

export const PhotoButtonInput = styled.div`
  width: 4rem;
  height: 4rem;
  position: relative;
  background: ${ colors.lightGrey };
  color: darkgrey;
  border-radius: 4px;
  cursor: pointer;
  &:before {
    content: '+';
    font-size: ${ fonts.fontSize.XXXXL }px;
    font-weight: ${ fonts.fontWeight.medium };
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
